
import { Table } from "@/components/ui/table";
import { Staff } from "@/types/staff";
import { StaffTableHeader } from "./table/StaffTableHeader";
import { SearchBar } from "./table/SearchBar";
import { Pagination } from "./table/Pagination";
import { TableContent } from "./table/TableContent";

interface StaffTableProps {
  staff: Staff[];
  loading: boolean;
  onDelete: (staff: Staff) => void;
  onStaffUpdated: () => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  page: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
}

export const StaffTable = ({ 
  staff, 
  loading, 
  onDelete, 
  onStaffUpdated,
  searchQuery,
  onSearchChange,
  page,
  pageSize,
  totalCount,
  onPageChange,
}: StaffTableProps) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <div className="relative space-y-4">
      <div className="flex items-center justify-end pb-4 gap-4">
        <SearchBar 
          searchQuery={searchQuery} 
          onSearchChange={onSearchChange} 
        />
      </div>

      <Table>
        <StaffTableHeader />
        <TableContent
          loading={loading}
          staff={staff}
          searchQuery={searchQuery}
          onDelete={onDelete}
          onStaffUpdated={onStaffUpdated}
        />
      </Table>

      <Pagination
        page={page}
        totalPages={totalPages}
        loading={loading}
        onPageChange={onPageChange}
      />
    </div>
  );
};
